import { render, staticRenderFns } from "./AdditionalTariffs.vue?vue&type=template&id=8cfbf6d0&scoped=true"
import script from "./AdditionalTariffs.vue?vue&type=script&lang=js"
export * from "./AdditionalTariffs.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8cfbf6d0",
  null
  
)

export default component.exports